/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Cell, Grid, Text } from 'bold-ui'
import theme from 'config/theme'
import { Fragment, useState } from 'react'
import { EditableList } from 'view/atendimentos/detail/components/EditableList'

import EditarEvolucoesPeriodontaisFormModal from '../EditarEvolucoesPeriodontaisFormModal'
import { EvolucoesPeriodontaisFieldModel } from '../EvolucoesPeriodontaisField'
import { EvolucoesPeriodontaisFormModel } from '../EvolucoesPeriodontaisForm'
import EvolucoesPeriodontaisTableRow from './EvolucoesPeriodontaisTableRow'

export interface EvolucoesPeriodontaisTableProps {
  items?: EvolucoesPeriodontaisFieldModel[]
  cidadaoDataNascimento?: LocalDate
  updateItem?(item: EvolucoesPeriodontaisFieldModel): void
  removeItem?(item: EvolucoesPeriodontaisFieldModel): void
}

export default function EvolucoesPeriodontaisTable(props: EvolucoesPeriodontaisTableProps) {
  const { items, cidadaoDataNascimento, updateItem, removeItem } = props

  const [modalItem, setModalItem] = useState<EvolucoesPeriodontaisFieldModel>(undefined)

  const onSubmitEdicao = (values: EvolucoesPeriodontaisFormModel) => {
    const { sextantes, ...rest } = values
    updateItem({ ...rest, sextante: sextantes[0] })
  }

  return (
    items &&
    items.length > 0 && (
      <Fragment>
        <EditableList
          css={css`
            background-color: ${theme.pallete.primary.c100};
          `}
        >
          <div css={classes.tableHeader}>
            <Grid>
              <Cell size={3}>
                <Text fontWeight='bold'>Local</Text>
              </Cell>
              <Cell size={7}>
                <Text fontWeight='bold'>Procedimentos</Text>
              </Cell>
              <Cell size={2} />
            </Grid>
          </div>

          {items.map((item, key) => (
            <EvolucoesPeriodontaisTableRow key={key} item={item} updateItem={setModalItem} removeItem={removeItem} />
          ))}
        </EditableList>

        <EditarEvolucoesPeriodontaisFormModal
          open={!!modalItem}
          cidadaoDataNascimento={cidadaoDataNascimento}
          initialValues={{ ...modalItem, sextantes: [modalItem?.sextante] }}
          evolucoesAtuais={items}
          onSubmit={onSubmitEdicao}
          onClose={() => setModalItem(undefined)}
        />
      </Fragment>
    )
  )
}

const classes = {
  tableHeader: css`
    padding: 0.5rem 1rem;
    background-color: ${theme.pallete.primary.c100};
    border-bottom: 1px solid ${theme.pallete.divider};
  `,
}
